module.exports = __webpack_public_path__ + "media/application/images/svgs/file-text-a6222f73e3564e463a75d14e914eecc4.svg";